import React from "react";
import styles from "./SkeletonLoaderCard.module.scss";
import classNames from "classnames";

export default function SkeletonLoaderCard({ style, border }) {
    return (
        <div className={classNames(styles["card"], border && styles["card-with-border"])} style={style}>
            <div className={styles["card-image"]} />
            <div className={styles["card-content-wrapper"]}>
                <h2 className={styles["card-content"]} />
            </div>
        </div>
    );
}
